module.exports = __webpack_public_path__ + "static/media/portfolio8-0.fff3f9ac.png";